export default import.meta.ROLLDOWN_FILE_URL_3yEMwsh83MD1OJOoqk9INA